function Tag( data ) {
	this.name = null;

	parse( this, data );

	function parse( context, data ) {
		// Code
		context.name = data ? data : null;
	}
}

module.exports = Tag;



//////////////////
// WEBPACK FOOTER
// ./src/modules/mediaplayer/liveStreamConfigApi/Tag.js
// module id = 76
// module chunks = 0